
<div #filter>
  <button *ngIf="isCustomGrid" (click)="OnSearchCustomgrid()" class="col-auto q-btn q-white searchBtn mr-2"><i class="fas fa-search"></i></button>
  <i class="fas fa-circle mr-2" [ngClass]="[ planningService.SumPlannedHours > HeuresStages ? 'q-c-danger' : planningService.SumPlannedHours == HeuresStages ? 'q-c-success' : 'q-c-warning' ]"></i>
  {{planningService.SumPlannedHours}} heure(s) planifiée(s) sur les {{HeuresStages}} heure(s) du stage.
  <ng-container *ngIf="HeuresStages > planningService.SumPlannedHours"> Reste à planifier {{HeuresStages - planningService.SumPlannedHours | NumbertoFixed}} heure(s)</ng-container>
  <ng-container *ngIf="HeuresStages < planningService.SumPlannedHours"> Planification dépassée de {{planningService.SumPlannedHours - HeuresStages | NumbertoFixed}} heure(s)</ng-container>
</div>
<ng-container *ngIf="planningService.ListeReservations">
  <ng-container *ngIf="planningService?.View == planningOnglet.Planning && !isCustomGrid">
    <button class="btn q-btn q-success m-1" type="button" (click)="open(ModalEditReservation);InitReservForUpdate();"
            title="Modifier les réservations sélectionnées" [disabled]="!HasReservSelected()">
      <i *ngIf="!editLoading" class="fas fa-edit"></i> <i *ngIf="editLoading" class="fas fa-spin fa-spinner fa-pulse"></i>
      Modifier les réservations
    </button>
    <button class="btn q-btn q-danger m-1" type="button" (click)="SetExtendedDeleteMessage(planningService.ListeReservations); open(ModalDeleteReservation, false)"
            title="Supprimer les réservations sélectionnées" [disabled]="!HasReservSelected()">
      <i class="fas fa-trash-alt"></i>
      Supprimer les réservations
    </button>
  </ng-container>
  <ng-container *ngIf="planningService?.View == planningOnglet.SuiviPresence && !isCustomGrid">
    <button class="btn q-btn q-success m-1" type="button" (click)="OpenEditPresence(ModalEditPresence);"
            title="Modifier les réservations sélectionnées" [disabled]="!HasReservSelected()">
      <i *ngIf="!editLoading" class="fas fa-edit"></i> <i *ngIf="editLoading" class="fas fa-spin fa-spinner fa-pulse"></i>
      Modifier les présences
    </button>
  </ng-container>
  <!-- CUSTOMGRID -->
  <div *ngIf="isCustomGrid && planningService?.View == planningOnglet.SuiviPresence">
    <q-customgrid [customgridName]="customgridPresenceFileName"
                  [completeWhere]="customgridWhere"
                  [(refreshData)]="refreshPresenceData">
    </q-customgrid>
  </div>
  <div *ngIf="isCustomGrid && planningService?.View == planningOnglet.Planning">
    <q-customgrid [customgridName]="customgridPlanningFileName"
                  [completeWhere]="customgridWhere"
                  [(refreshData)]="refreshPlanningData">
    </q-customgrid>
  </div>

  <div *ngIf="!isCustomGrid" class="row">
    <div *ngFor="let reserv of planningService.sortedReservations; let i = index" [ngClass]="[planningService?.View == planningOnglet.Planning || (planningService?.View == planningOnglet.SuiviPresence && reserv.Ident && reserv.Ident != '0') ? (!reserv?.IsEdit ? 'col-xl-6': 'col-12') : '']">
      <div class="row q-reserv-card m-1" *ngIf="(planningService?.View == planningOnglet.Planning || (planningService?.View == planningOnglet.SuiviPresence && reserv.Ident && reserv.Ident != '0')) && reserv" [ngClass]="{'resa-conflit': reserv.Conflits?.length > 0, 'q-card-temp': !reserv.Ident || reserv.Ident == '0'}">
        <ng-container *ngIf="reserv.Conflits?.length > 0">
          <i class="fas fa-exclamation-circle q-c-danger position-absolute q-exclamation-conflict"
             [ngbPopover]="f2"
             [placement]="['top', 'auto']"
             triggers="mouseenter:mouseleave"
             container="body"
             #p2="ngbPopover"></i>

          <ng-template #f2>
            <div class="w-100">
              <ng-container *ngFor="let conflit of reserv.Conflits">
                <div class="w-100">
                  <strong>- {{conflit.NomItem}} :</strong>
                  <span>{{conflit.NomResa}}</span>
                </div>

              </ng-container>
            </div>
          </ng-template>
        </ng-container>

        <div class="col-3 q-reserv-cardleft" [ngClass]="[
             planningService?.View == planningOnglet.SuiviPresence ? (reserv.Etat == etatPresence.OK ? 'q-success' : reserv.Etat == etatPresence.PARTIAL ? 'q-warning' : reserv.Etat == etatPresence.NONE ? 'q-danger' : 'q-secondary') : (!reserv.Ident || reserv.Ident == '0' ? 'q-warning' : 'q-secondary')]">
          <div *ngIf="reserv.TypeReserv == 'Intervalle'">
            <div class="row justify-content-center q-text-type mt-1 text-center">
              {{reserv.TypeReserv}}
            </div>
            <div class="row justify-content-center text-center">
              Du {{reserv.ShortDate}}
            </div>
            <div class="row justify-content-center text-center">
              au {{reserv.ShortDateEnd}}
            </div>
          </div>
          <div *ngIf="reserv.TypeReserv != 'Intervalle'">
            <div class="row justify-content-center q-text-day mt-1 text-center">
              {{reserv.ShortDate}}
            </div>
            <div class="row justify-content-center text-center">
              {{reserv.JourSemaine}}
            </div>

            <div class="row justify-content-center q-text-type mt-1 text-center">
              {{reserv.TypeReserv}}
            </div>
            <div class="row justify-content-center q-test-hours mt-1 text-center">
              {{reserv.DateDebut.heures}}h{{reserv.DateDebut.minutes}} - {{reserv.DateFin.heures}}h{{reserv.DateFin.minutes}}
            </div>
          </div>

        </div>
        <!--CARTE EN ONGLET PLANNING-->
        <div class="col-9" *ngIf="planningService?.View == planningOnglet.Planning">
          <div class="q-check">
            <input type="checkbox" id="{{reserv.Ident}}-{{i}}" [(ngModel)]="reserv.IsSelected" (change)="SetListChecked()" />
            <label class="q-label-checkreserv" for="{{reserv.Ident}}-{{i}}">
              <span class="q-span-checkreserv"></span>
            </label>

          </div>
          <div class="row no-gutters">
            <div class="py-1 col-auto">
              {{reserv.Titre}}
            </div>
            <div class="col-2 ml-2" *ngIf="reserv.IsSynchroSWS">
              <i class="fa-regular fa-thumbs-up q-c-success" title="Réservation synchronisée dans SoWeSign"><span class="ml-1">sws</span></i>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-6 pr-0">
              <div *ngIf="planningService.ListeFormateurs && planningService.ListeFormateurs.length > 0 " class="row ml-1 align-items-center">
                <strong class="mr-1">Formateurs :</strong>

                <q-avatar-search [elementList]="planningService.ListeFormateurs"
                                 labelPropName="Value"
                                 identPropName="Id"
                                 imgPropName="ProfilePicture"
                                 [value]="reserv.Formateurs | PersonToListId"
                                 (selectedList)="SetFormateurList(reserv, $event)"
                                 [multipleSelection]="true" class="d-inline-block">
                </q-avatar-search>
              </div>

            </div>
            <div class="col-6 pl-0">
              <div class="row no-gutters">
                <div class="col-10 text-right mt-1">
                  <div *ngIf="!AnyObjectSelected(reserv)" class="mt-1">
                    Ajouter options :
                  </div>
                  <div *ngIf="OneObjectSelected(reserv)" class="mt-1">
                    <strong>{{GetSelectedGroup(reserv)}}</strong> {{GetSelectedObject(reserv)}}
                  </div>
                  <div *ngIf="!OneObjectSelected(reserv) && AnyObjectSelected(reserv)" class="mt-1">
                    options :
                  </div>
                </div>
                <div class="col-2">
                  <!-- A revoir -->
                  <button class="selected-element-container ml-2 q-pointer"
                          [ngClass]="{'empty-objects': !AnyObjectSelected(reserv)}"
                          [ngbPopover]="f1"
                          [placement]="['top', 'auto']"
                          [autoClose]="'outside'"
                          container="body"
                          #p1="ngbPopover"
                          popoverClass="popoverInfoReserv"
                          (click)="SetObjectListSelected(reserv)"
                          title="Ajouter des options">
                    <i class="fas fa-desktop"></i>
                    <div *ngIf="!OneObjectSelected(reserv) && AnyObjectSelected(reserv)">
                      <div class="number-circle" [title]="GetListObject(reserv.ObjetReserves)">
                        {{NumberObjectSelected(reserv)}}
                      </div>
                    </div>
                  </button>
                </div>


              </div>
            </div>
          </div>

          <div class="row mt-2 mb-1">
            <div class="col-10 d-flex">
              <div *ngIf="reserv.TypeReserv == 'Intervalle'">
                Du <strong>{{reserv.DateDebut.jour}}/{{reserv.DateDebut.mois}}</strong> au <strong>{{reserv.DateFin.jour}}/{{reserv.DateFin.mois}}</strong>
              </div>
              <div *ngIf="reserv.TypeReserv != 'Intervalle'">
                De <strong>{{reserv.DateDebut.heures}}:{{reserv.DateDebut.minutes}}</strong> à <strong>{{reserv.DateFin.heures}}:{{reserv.DateFin.minutes}}</strong>
              </div>
              <i class="fas fa-clock q-c-main ml-3 mt-1 mr-1"></i> {{reserv.Duree}} h
              <div *ngIf="reserv.HasZoom" class="ml-2"><i class="fas fa-video q-c-main" style="font-size: 1.75em; vertical-align: -0.2em;"></i></div>
            </div>
            <div class="col-2">
              <!--<div class="d-flex align-items-end q-pointer q-text-s float-right" (click)="openBo(reserv)"><i class="fas fa-edit q-c-main ml-2 mt-2"></i></div>-->
              <div class="d-flex align-items-end q-pointer q-text-s float-right" (click)="openBoUnder(reserv)" *ngIf="!reserv.IsEdit" title="Ouvrir la réservation"><span class="q-c-main ml-2 mt-2">Modifier</span></div>
              <div class="d-flex align-items-end q-pointer q-text-s float-right" (click)="closeEdit(reserv)" *ngIf="reserv.IsEdit" title="Fermer la réservation"><span class="q-c-main ml-2 mt-2">Retour</span></div>
            </div>
          </div>

        </div>


        <!--CARTE ONGLET SUIVI PRESENCE-->
        <div class="col-9 q-pointer" title="voir les présences" *ngIf="planningService?.View == planningOnglet.SuiviPresence">
          <div class="q-check">
            <input type="checkbox" id="{{reserv.Ident}}-{{i}}" [(ngModel)]="reserv.IsSelected" (change)="SetListChecked()" />
            <label class="q-label-checkreserv" for="{{reserv.Ident}}-{{i}}">
              <span class="q-span-checkreserv"></span>
            </label>
          </div>
          <div (click)="openSuiviPresence(reserv)">
            <div class="row no-gutters">
              <div class="py-1 col-auto">
                {{reserv.Titre}}
              </div>
              <div class="col-2 ml-2" *ngIf="reserv.IsSynchroSWS">
                <i class="fa-regular fa-thumbs-up q-c-success" title="Réservation synchronisée dans SoWeSign"><span class="ml-1">sws</span></i>
              </div>
            </div>
            <div class="row no-gutters">
              <div *ngIf="reserv.Formateurs && reserv.Formateurs.length > 0" class="d-flex">
                <span class="mt-1">Formateurs : </span>
                <div *ngIf="reserv.Formateurs.length < 6" class="d-flex">
                  <div *ngFor="let form of reserv.Formateurs" class="mx-1"
                       title="{{form.Firstname}} {{form.Lastname}}">
                    <img src="{{form.ProfilePicture}}" onerror="this.onerror=null; this.src='assets/images/Profil.png'" loading="lazy" class="ImgUser">
                  </div>
                </div>
                <div *ngIf="reserv.Formateurs.length > 5">
                  <div class="selected-element-container ml-2" [title]="GetListFormateur(reserv.Formateurs)">
                    <i class="fas fa-user-plus fa-flip-horizontal"></i>
                    <div class="number-circle">
                      {{reserv.Formateurs.length}}
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!reserv.Formateurs || reserv.Formateurs.length == 0" class="d-flex">
                <span class="mt-1">Aucun formateur </span>
                <img src="assets/images/Profil.png" onerror="this.onerror=null; this.src='assets/images/Profil.png'" loading="lazy" class="ImgUser">
              </div>
            </div>
            <div class="row mt-2 mb-1" *ngIf="planningService?.View == planningOnglet.SuiviPresence">
              <div class="col-10 d-flex">
                <div class="mx-1">N.A. : {{reserv.NbNa}}</div>
                <div class="mx-1">Préins : {{reserv.NbPreinsc}}</div>
                <div class="mx-1">Prés. : {{reserv.NbPresent}}</div>
                <div class="mx-1">Abs. : {{reserv.NbAbs}}</div>
                <div class="mx-1">Abs. Injust. : {{reserv.NbAbsInj}}</div>
              </div>
              <div class="col-2">
                <div class="d-flex align-items-end q-pointer q-text-s float-right" *ngIf="!reserv.IsEdit">
                  <span>Modifier</span>
                  <!--<i *ngIf="!isLoading || reserv.Ident != planningService.idReserv" class="fas fa-check-circle q-c-main ml-2 mt-2"></i>-->
                  <i *ngIf="isLoading && reserv.Ident == planningService.idReserv" class="fas fa-spin fa-spinner fa-pulse q-c-main"></i>
                </div>
                <div class="d-flex align-items-end q-pointer q-text-s float-right" *ngIf="reserv.IsEdit"><span class="q-c-main ml-2 mt-2">Retour</span></div>
              </div>
            </div>
          </div>

        </div>


        <ng-container *ngIf="reserv.IsEdit">
          <div class="w-100 q-zone-bo m-2">
            <ng-container *ngIf="planningService?.View != planningOnglet.SuiviPresence else templateEditSuiviPresence">
              <ng-container *ngIf="!reserv.Ident || reserv.Ident == '0'">
                <button class="q-btn q-main" (click)="OnGetBo(BoDisplay.model, reserv);RefreshReserv(reserv);closeEdit(reserv);"><i class="fas fa-save"></i></button>
                <br />
              </ng-container>
              <label class="q-bo-label">Choisir une adresse de convocation pour la réservation :</label>
              <select class="q-main-select mb-2" (change)="SelectLieu($event.target.value, reserv)">
                <option *ngFor="let adr of planningService.ListeLieux" [selected]="adr.id != null && adr.id == reserv.IdLieu" value="{{adr.id}}">{{adr.value}}</option>
              </select>
              <label class="q-bo-label">Affectation pour gestion des réservations multi-stages :</label>
              <select class="q-main-select mb-2" (change)="SelectBureau($event.target.value, reserv)">
                <option *ngFor="let bur of planningService.ListeBureaux" [selected]="bur.id != null && bur.id == reserv.IdBureau" value="{{bur.id}}">{{bur.value}}</option>
              </select>
              <ng-container *ngIf="reserv.Ident && reserv.Ident != '0' else boReservTemp">
                <br />
                <label class="q-bo-label">Supprimer la réservation :</label>
                <button class="btn q-btn q-danger m-1" type="button" (click)="openDeleteOne(reserv, ModalDeleteOneReservation)"
                        title="Supprimer la réservation">
                  <i class="fas fa-trash-alt"></i>
                </button>
                <div>
                  <q-bodisplay class="w-100 mb-5" [item]="reserv.BoReserv" (sendEvent)="RefreshReserv(reserv);closeEdit(reserv);"></q-bodisplay>
                </div>
              </ng-container>
              <ng-template #boReservTemp>
                <div>
                  <q-bodisplay #bodisplay class="w-100 mb-5" [param]="planningService.boParam"></q-bodisplay>
                </div>
              </ng-template>

            </ng-container>
            <ng-template #templateEditSuiviPresence>
              <div class="row mt-2">
                <div class="col-md-12 mt-3">
                  <ng-container *ngTemplateOutlet="tablePresence; context {apprenants: listApprenant, multiReservs: false}"></ng-container>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>


  </div>
  <div class="row mt-2 justify-content-center">
    <label class="q-text-s" *ngIf="planningService.displayShowMore">{{planningService.PaginationInfo()}}</label>
  </div>
  <div class="row justify-content-center">
    <button *ngIf="planningService.displayShowMore" (click)="planningService.PaginationReservation()" class="q-btn q-main" [title]="planningService.PaginationInfo()">Afficher plus</button>
  </div>
  <div class="row m-2 justify-content-center" *ngIf="planningService?.View == planningOnglet.Planning">
    <button class="q-btn q-main" *ngIf="ShowSaveNewReserv() && !isLoading" (click)="SaveNewReserv()">Enregistrer le découpage</button>
    <i *ngIf="isLoading" class="fas fa-spin fa-spinner fa-pulse q-c-main"></i>
  </div>
</ng-container>

<ng-template #f1>
  <div class="w-100">
    <ng-container *ngFor="let groupe of ReservSelected.ObjetReserves?.Children">
      <div class="w-100 q-c-main">
        <strong>{{groupe.Text}} :</strong><button (click)="showGroup(groupe)" class="q-btn groupBtn"><i [ngClass]="groupe.IsVisible ? 'fas fa-chevron-circle-up' : 'fas fa-chevron-circle-down'" class="q-c-main"></i></button>
      </div>
      <ng-container *ngFor="let object of groupe.Children">
        <div [ngClass]="groupe.IsVisible ? 'd-block' : 'd-none'">
          <div class="row px-2 q-pointer" [ngClass]="[object.IsChecked ? 'q-bold q-hover' : 'q-light-hover']"
               [title]="(object.IsChecked ? 'Retirer' : 'Ajouter') + ' ' + object.Text"
               (click)="moveItem(groupe, object)">
            <span>{{object.Text}}</span>
            <span [ngClass]="{'invisible': !object.IsChecked}" class="fa-stack q-c-main fa-xs q-btn-partdelete float-right ml-auto" title="retirer le collaborateur">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            </span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- Modals Reservation Grid -->
<ng-template #ModalReservationGrid class="modal-dialog-centered" let-modalReservationGrid>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modalReservationGrid.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div>
      <q-reservation class="reservation" [param]="param" (sendEvent)="goBack(); modalReservationGrid.dismiss();" (closeModale)="modalservice.dismissAll()"></q-reservation>
    </div>
  </div>
</ng-template>

<!--  MODAL de validation de la mise à jour de la durée de la  réservation -->
<ng-template #ModalUpdateDuree let-modalUpdateDuree>
  <div class="row mx-0 modal-header position-relative">
    <h5 class="q-c-main text-center">La durée de votre réservation va passer de {{newReservRefresh.Duree}} heures de travail à {{newDureeHeure}} heures.</h5>
    <h5 class="q-c-main text-center">Voulez vous mettre à jour la durée de la reservation ?</h5>
    <i class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: 7px;" data-dismiss="modal" aria-label="Close" (click)="modalUpdateDuree.dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <button class="btn q-btn q-success m-2" type="button" (click)="UpdateReserv();modalUpdateDuree.dismiss()"
              title="Mettre à jour la durée de la réservation">
        Oui
      </button>
      <button class="btn q-btn q-danger m-2" type="button" (click)="modalUpdateDuree.dismiss()" >
        Non
      </button>
    </div>
  </div>
</ng-template>

<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modal>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div>
      <q-bodisplay class="w-100 mb-5" [item]="ReservSelected.BoReserv" (sendEvent)="modal.dismiss()"></q-bodisplay>
    </div>
  </div>
</ng-template>



<!--  MODAL de validation de la suppression des réservations -->
<ng-template #ModalDeleteReservation let-modalDelete>
  <div class="row mx-0 modal-header position-relative">
    <h5 class="q-c-main text-center">{{extendedDeleteMessage}} Etes-vous sûr de vouloir supprimer définitivement ces réservations ?</h5>
    <i class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: 7px;" data-dismiss="modal" aria-label="Close" (click)="modalDelete.dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="DeleteReserv();modalDelete.dismiss()"
              title="Supprimer les réservations" [disabled]="!HasReservSelected()">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>

<!--  MODAL de validation de la suppression d'une réservation -->
<ng-template #ModalDeleteOneReservation let-modalDeleteOne>
  <div class="row mx-0 modal-header position-relative">
    <h5 class="q-c-main text-center">{{extendedDeleteMessage}} Etes-vous sûr de vouloir supprimer cette réservation ?</h5>
    <i class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: 7px;" data-dismiss="modal" aria-label="Close" (click)="modalDeleteOne.dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="DeleteOneReserv();modalDeleteOne.dismiss()"
              title="Supprimer la réservation">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>

<!--  MODAL de modification des réservations -->
<ng-template #ModalEditReservation let-modalEdit>
  <div class="row mx-0 modal-header position-relative">
    <div class="col-12">Reprendre le paramétrage :</div>
    <div class="col-12">
      <select class="q-main-select mb-2" (change)="SetReservForUpdate($event.target.value)" style=" max-width: 100%;">
        <option value="0">d'aucune réservation</option>
        <option *ngFor="let reserv of ListReservChecked" [selected]="reserv.Ident != null && reserv.Ident == ReservForUpdate.Ident && reserv.DateDebut == ReservForUpdate.DateDebut" value="{{reserv.Ident}}|{{reserv.ShortDate}}|{{reserv.TypeReserv}}">{{reserv.Titre}} ({{reserv.JourSemaine}} {{reserv.ShortDate}} {{reserv.TypeReserv}})</option>
      </select>
    </div>
    <i class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: 7px;" data-dismiss="modal" aria-label="Close" (click)="modalEdit.dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="ml-3">
      <strong>Modification des réservations sélectionnées</strong>
    </div>
    <div class="ml-3">
      <label class="mr-1">Titre:</label>
      <input type="text" [(ngModel)]="ReservForUpdate.Titre" />
    </div>
    <div class="row no-gutters mt-3">
      <div class="ml-3 d-flex" *ngIf="planningService.ListeFormateurs && planningService.ListeFormateurs.length > 0 ">
        <label class="mr-1">Formateurs :</label>
        <div class="checkbox checbox-switch switch-primary d-inline text-left">
          <label>
            <input type="checkbox" [(ngModel)]="ReservForUpdate.ShowTrainer" />
            <span></span>
          </label>
        </div>
        <div class="mb-1">
          <q-avatar-search [elementList]="planningService.ListeFormateurs"
                           labelPropName="Value"
                           identPropName="Id"
                           imgPropName="ProfilePicture"
                           [value]="ReservForUpdate.Formateurs | PersonToListId"
                           (selectedList)="SetFormateurList(ReservForUpdate, $event)"
                           [multipleSelection]="true" class="d-inline-block" *ngIf="ReservForUpdate.ShowTrainer">
          </q-avatar-search>
        </div>
      </div>
      <div class="ml-3 d-flex" *ngIf="planningService.Objets">
        <label class="mr-1">Objets :</label>
        <div class="checkbox checbox-switch switch-primary d-inline text-left">
          <label>
            <input type="checkbox" [(ngModel)]="ReservForUpdate.ShowObject" />
            <span></span>
          </label>
        </div>
        <button class="selected-element-container ml-2 q-pointer"
                [ngClass]="{'empty-objects': !AnyObjectSelected(ReservForUpdate)}"
                [ngbPopover]="f1"
                [placement]="['top', 'auto']"
                [autoClose]="'outside'"
                container="body"
                #p1="ngbPopover"
                (click)="SetObjectListSelected(ReservForUpdate)" *ngIf="ReservForUpdate.ShowObject">
          <i class="fas fa-desktop"></i>
          <div *ngIf="AnyObjectSelected(ReservForUpdate)">
            <div class="number-circle" [title]="GetListObject(ReservForUpdate.ObjetReserves)">
              {{NumberObjectSelected(ReservForUpdate)}}
            </div>
          </div>
        </button>

      </div>
    </div>
    <div class="row no-gutters mt-3">
      <div class="ml-3">
        <label class="mr-1">Lieu de convocation :</label>
        <div class="checkbox checbox-switch switch-primary d-inline text-left">
          <label>
            <input type="checkbox" [(ngModel)]="ReservForUpdate.ShowLocation" />
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="row no-gutters" *ngIf="ReservForUpdate.ShowLocation">
      <select class="q-main-select ml-3" (change)="SelectLieu($event.target.value, ReservForUpdate)">
        <option *ngFor="let adr of planningService.ListeLieux" [selected]="adr.id != null && adr.id == ReservForUpdate.IdLieu" value="{{adr.id}}">{{adr.value}}</option>
      </select>
    </div>
    <div class="row no-gutters mt-3">
      <div class="ml-3">
        <label class="mr-1">Bureau :</label>
        <div class="checkbox checbox-switch switch-primary d-inline text-left">
          <label>
            <input type="checkbox" [(ngModel)]="ReservForUpdate.ShowOffice" />
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="row no-gutters" *ngIf="ReservForUpdate.ShowOffice">
      <select class="q-main-select ml-3" (change)="SelectBureau($event.target.value, ReservForUpdate)" *ngIf="ReservForUpdate.ShowOffice">
        <option *ngFor="let bur of planningService.ListeBureaux" [selected]="bur.id != null && bur.id == ReservForUpdate.IdBureau" value="{{bur.id}}">{{bur.value}}</option>
      </select>
    </div>
    <div class="row no-gutters mt-3">
      <div class="ml-3">
        <label class="mr-1">Disponibilité :</label>
        <div class="checkbox checbox-switch switch-primary d-inline text-left">
          <label>
            <input type="checkbox" [(ngModel)]="ReservForUpdate.ShowDispo" />
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="row no-gutters" *ngIf="ReservForUpdate.ShowDispo">
      <select class="q-main-select ml-3" (change)="SelectDispo($event.target.value, ReservForUpdate)">
        <option value="0">Choisir une disponibilité</option>
        <option *ngFor="let dispo of planningService.ListeDispo" [selected]="dispo.id != null && dispo.id == ReservForUpdate.CodeDispo" value="{{dispo.id}}">{{dispo.value}}</option>
      </select>
    </div>
    <div class="row m-2 justify-content-center">
      <button class="q-btn q-main" *ngIf="CanUpdate()" (click)="SaveListReserv();modalEdit.dismiss()">Appliquer les modifications</button>
    </div>
  </div>
</ng-template>


<!--  MODAL de modification des présences -->
<ng-template #ModalEditPresence let-modalPresence>
  <div class="row mx-0 modal-header position-relative" style=" border-bottom: 1px solid white;">
    <span class="mx-auto q-bold text-center">Affectation des présences sur toutes les réservations sélectionnées</span>
    <i class="fas fa-times q-c-danger q-pointer position-absolute" style="right: 7px; top: 7px;" data-dismiss="modal" aria-label="Close" (click)="modalPresence.dismiss()"></i>
  </div>
  <div class="modal-body table-container">
    <ng-container *ngTemplateOutlet="tablePresence; context {modalPresence: modalPresence, apprenants: apprenantsForUpdate, multiReservs: true}"></ng-container>
  </div>
</ng-template>


<ng-template #tablePresence let-modalPresence="modalPresence" let-apprenants="apprenants" let-multiReservs="multiReservs">
  <table class="table table-striped table-condensed" style="font-size:0.8rem;" *ngIf="apprenants && apprenants.length > 0">
    <thead>
      <tr>
        <th scope="col"> N° Stages</th>

        <th scope="col">{{ 'learner' | trad }}</th>

        <th scope="col"></th>
        <th scope="col" title="Non Affecté">
          <input [disabled]="savingPresence" type="radio" value="0" [ngModel]="multiReservs ? globalPresenceMulti : globalPresence" name="headcoll" (click)="SetAllPresence('0', multiReservs);">&nbsp;Non Affecté
        </th>
        <th scope="col" title="Préinscrit">
          <input [disabled]="savingPresence" type="radio" value="PI" [ngModel]="multiReservs ? globalPresenceMulti : globalPresence" name="headcoll" (click)="SetAllPresence('PI', multiReservs);">&nbsp;Préinscrit
        </th>
        <th scope="col" title="{{ 'present' | trad}}">
          <input [disabled]="savingPresence" type="radio" value="P" [ngModel]="multiReservs ? globalPresenceMulti : globalPresence" name="headcoll" (click)="SetAllPresence('P', multiReservs);">&nbsp;Présent
        </th>
        <th scope="col" title="{{ 'absent' | trad }}">
          <input [disabled]="savingPresence" type="radio" value="A" [ngModel]="multiReservs ? globalPresenceMulti : globalPresence" name="headcoll" (click)="SetAllPresence('A', multiReservs);">&nbsp;Absent
        </th>
        <th scope="col" title="{{ 'unjustified' | trad }}">
          <input [disabled]="savingPresence" type="radio" value="AI" [ngModel]="multiReservs ? globalPresenceMulti : globalPresence" name="headcoll" (click)="SetAllPresence('AI', multiReservs);">&nbsp;Absence Injustifiée
        </th>
        <th scope="col">
          <input [disabled]="savingPresence" type="radio" value="" [ngModel]="globalPresence" name="headcoll" class="d-none">
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let appr of apprenants; let i = index">
        <td class="q-bold"><span [ngClass]="appr.strNumeroStage.includes(stageService.Stage.NumStage.toString()) ? 'q-c-success' : 'q-c-warning'">{{appr.strNumeroStage}}</span></td>
        <th scope="row">
          <p class="mb-0">
            <span>{{appr.strNom}} {{appr.strPrenom}}</span>
          </p>
        </th>
        <td>
          <div *ngIf="appr.pathEmargement"
               [ngbPopover]="f1"
               [placement]="['auto', 'auto']"
               autoClose="outside"
               container="body"
               #p1="ngbPopover"
               class="q-pointer"
               style="border: 2px solid var(--c-main);">
            <div class="w-100 h-100" ngbPopover="{{ appr.infoEmargement}}" [disablePopover]="p1.isOpen()" triggers="mouseenter:mouseleave">

              <img *ngIf="!appr.pathExistButUnfounded" style="max-width: 48px;max-height: 48px" [src]="sanitize.bypassSecurityTrustResourceUrl(appr.pathEmargement)" />
              <i *ngIf="appr.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
            </div>
            <ng-template #f1>
              <img *ngIf="!appr.pathExistButUnfounded" [src]="sanitize.bypassSecurityTrustResourceUrl(appr.pathEmargement)" />
              <i *ngIf="appr.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
              <button *ngIf="!deletingSignature" class="q-btn q-danger" (click)="DeleteStgSignature(appr.strIdent, multiReservs, 'REL_BO_CONTACT_BO_RESERV_P', appr)"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
              <button *ngIf="deletingSignature" class="q-btn q-danger"><i class="fas fa-spin fa-pulse fa-spinner mr-2"></i>Supprimer la signature</button>
            </ng-template>
          </div>
        </td>
        <td><input [disabled]="savingPresence" type="radio" value="0" [ngModel]="appr.presence" (click)="UpdatePresence('0',apprenants, appr, multiReservs)" name="{{i}}" /></td>
        <td><input [disabled]="savingPresence" type="radio" value="PI" [ngModel]="appr.presence" (click)="UpdatePresence('PI',apprenants, appr, multiReservs)" name="{{i}}" /></td>
        <td><input [disabled]="savingPresence" type="radio" value="P" [ngModel]="appr.presence" (click)="UpdatePresence('P',apprenants, appr, multiReservs)" name="{{i}}" /></td>
        <td><input [disabled]="savingPresence" type="radio" value="A" [ngModel]="appr.presence" (click)="UpdatePresence('A',apprenants, appr, multiReservs)" name="{{i}}" /></td>
        <td><input [disabled]="savingPresence" type="radio" value="AI" [ngModel]="appr.presence" (click)="UpdatePresence('AI',apprenants, appr, multiReservs)" name="{{i}}" /></td>
        <td><input [disabled]="savingPresence" class="d-none" type="radio" value="" [ngModel]="appr.presence" name="{{i}}" /></td>
      </tr>
    </tbody>
  </table>
</ng-template>
